import React from "react";
import FooterNew from "../components_template/components/Footer/FooterNew";
import Testimonial from "../components/Testimonial2";
import CompanySlider from "../components/CompanySlider";
import Stats from "../components/Stats";
import TimelineForPlacekit from "../components/TimelineForPlaceKit";
import PagesData from "./PagesData";
import YouWillGet from "../components_template/components/YouWillGet";
import ApplyNowBtn from "../components/ApplyNowBtn";
import Navbar from "../components/Navbar";
import YoutubeVideo from "../components/YoutubeVideo";
import AboutInstructor from "../components/AboutInstructor";
import Pricing from "../components/Pricing";
import MainContent from "../components_template/components/TextContent/MainContent";
import ReferralSlider from "../components/ReferralSlider";
import PlacekitFeaturesCard from "../components/PlacekitFeaturesCard";

const PlaceKit = () => {
  const programdata = PagesData.placekit;

  return (
    <>
      <div
        style={{
          backgroundColor: "#0b001a",
          scrollBehavior: "smooth",
          userSelect: "none",
        }}
      >
        <Navbar />
        <MainContent data={programdata} />
        <Stats data={programdata} />
        <ReferralSlider />
        <YoutubeVideo />
        <PlacekitFeaturesCard data={programdata} />
        <AboutInstructor data={programdata} />
        <Pricing data={programdata} />
        <ApplyNowBtn data={programdata} />

        {programdata.showyouwillget ? (
          <YouWillGet data={programdata} />
        ) : (
          <div></div>
        )}

        {programdata.showtimeline ? (
          <TimelineForPlacekit data={programdata} />
        ) : (
          <div></div>
        )}

        <CompanySlider />
        <Testimonial />
        <FooterNew name={programdata} />
      </div>
    </>
  );
};

export default PlaceKit;
